import React from 'react';
import CategoryInsights from './CategoryInsights';

const BusinessNews = () => {
  return (
    <CategoryInsights
      category="business-news"
      titleKey="pages.businessNews.title"
      subtitleKey="pages.businessNews.subtitle"
      categoryLabelKey="insights.businessNews"
    />
  );
};

export default BusinessNews;
